import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Moment from 'moment';
import { isEmpty } from 'lodash';
import S from 'calendar.scss';

const CalendarTWD = ({ date, twd = {} }) =>
  <article
    className={cx(S.pto, {
      [S.hasNextDay]: !isEmpty(twd) && !date.startOf('day').isSame(Moment(twd.end_date)),
      [S.hasPreviousDay]: !isEmpty(twd) && !date.startOf('day').isSame(Moment(twd.start_date)),
    })}
  >Traveling Work Block</article>;

CalendarTWD.propTypes = {
  date: PropTypes.instanceOf(Moment).isRequired,
  assignee: PropTypes.shape({
    id: PropTypes.number.isRequired,
    kind: PropTypes.oneOf(['Estimator', 'Crew', 'IQM']).isRequired,
  }).isRequired,
  twd: PropTypes.shape({
    id: PropTypes.number.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    reason: PropTypes.string,
  }),
};

export default CalendarTWD;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarTWD.jsx